import React from "react";
import TeamMemberCard from "./TeamMemberCard";

const TeamMembers = ({ team, removeMember }) => {
  return (
    <div>
      <div className="flex justify-between p-[6px] px-[8px] items-center">
        <h3 className="mt-4 text-xl font-medium text-dark">Proje Ekibi</h3>
      </div>
      <div className="flex flex-col gap-2">
        {/* Yatay kaydırma alanı */}
        <div className="relative overflow-x-auto scrollbar-custom">
          <div className="flex p-2 w-max .min-w-full">
            {team && team.length > 0 ? (
              team.map((member) => (
                <TeamMemberCard
                  key={member.id || member._id || Math.random()} // Backend'den id gelmezse rastgele bir key
                  member={member}
                  removeMember={removeMember}
                />
              ))
            ) : (
              <p className="text-sm text-grayy">
                Proje ekibi henüz belirlenmemiş.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMembers;
